import { TFunction } from "next-i18next"
import { type TIconName } from "@/core/components/icon/IconUtil"

export enum ContractStatus {
  NotDefined = -1,
  Pending = 0,
  Active = 1,
  Rejected = 2,
  Cancelled = 3,
  Ended = 4,
}

export const CONTRACT_STATUS_ICONS: Record<ContractStatus, TIconName> = {
  [ContractStatus.Pending]: "hourglass",
  [ContractStatus.Active]: "check_circle",
  [ContractStatus.Rejected]: "cancel",
  [ContractStatus.Cancelled]: "cancel",
  [ContractStatus.Ended]: "check_circle",
  [ContractStatus.NotDefined]: "hourglass",
}

export const normalizeContractStatus = (
  status: number | null | undefined,
): ContractStatus => {
  if (status === null || status === undefined || Number.isNaN(status)) {
    return ContractStatus.Pending
  }
  switch (status) {
    case ContractStatus.Pending:
      return ContractStatus.Pending
    case ContractStatus.Active:
      return ContractStatus.Active
    case ContractStatus.Rejected:
      return ContractStatus.Rejected
    case ContractStatus.Cancelled:
      return ContractStatus.Cancelled
    case ContractStatus.Ended:
      return ContractStatus.Ended
    case ContractStatus.NotDefined:
      return ContractStatus.NotDefined
    default:
      return ContractStatus.Pending
  }
}

export const getContractStatusSelectOptions = (t: TFunction) =>
  [ContractStatus.Pending, ContractStatus.Active, ContractStatus.Rejected].map(
    (status) => ({
      label: t(`common:contract_status.${ContractStatus[status]}`),
      value: String(status),
      icon: CONTRACT_STATUS_ICONS[status],
    }),
  )
